module.exports = __webpack_public_path__ + "static/media/LR.78bb8ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/LR.svg
// module id = 301
// module chunks = 0